import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useStates } from '../../hooks';
import type { State, StateFilters, StatesParams } from '../../models';

export interface StateFieldProps extends Omit<SelectProps<State>, 'options'> {
  countryCode?: string;
  defaultFilters?: Partial<StateFilters & StatesParams & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<State>['errorMessage'];
  isInvalid?: boolean;
}

export const StateField: React.FC<StateFieldProps> = ({ countryCode, defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = useStates({ ...defaultFilters, CountryCode: countryCode ?? '' });

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { stateDesc: search ?? '' } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { stateDesc: search ?? '' } })}
      isLoading={isLoading}
    />
  );
};
